import { gql } from "@apollo/client";

const GET_DEDUCTION_ITEM = gql`
  query GetDeductionItem($params: GetDeductionItemsParams!) {
    deductionItems(params: $params) {
      count
      columns {
        key
        title
      }
      items {
        id
        notes
        poDate
        quantity
        allowance
        packSize
        poNumber
        shipDate
        unitCost
        expiryDate
        refInvoice
        deductionId
        invoiceDate
        totalAmount
        receivedDate
        retailerName
        invoiceAmount
        orderQuantity
        costDifference
        retailerNumber
        upcItemNumber
        itemDescription
        receivedUnitCost
        distributionCenter
        quantityDifference
        discount
        divisionName
        divisionNumber
        units
        ship
        productCategoryName
      }
    }
  }
`;

export default GET_DEDUCTION_ITEM;
